export enum PaymentType {
  PAYMENT_TYPE = 'PaymentType',
}
export enum PaymentTypeColumn {
  PAYMENT_TYPE = 'PaymentTypeEnum',
}
